export const userIdFromIdentity = (identity = "") => {
    // if identity itself is the mongo id
    if (/^[a-f\d]{24}$/i.test(identity)) return identity;

    // pattern: user_<mongoId>_anything
    const m = /^user_([a-f\d]{24})_/i.exec(identity);
    return m?.[1] ?? null;
};

export const joinCacheKey = (sessionId, tableId) =>
    `livekitJoin:${String(sessionId)}:${String(tableId)}`;